export default __webpack_public_path__ + "static/media/md-loss-card-img.bbc2252a.svg";